// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__MsxG2","title":"InfoRow_title__3Km4a"};